import { createSelector } from '@ngrx/store';

import { onlineOrderState } from '../root';

export const isOrderRecalculating = createSelector(onlineOrderState, (onlineOrder) => {
    const isOngoingRecalculate = onlineOrder.recalculateRequest.isRecalculating === true;
    const isOngoingConfirmingPreparationTime = onlineOrder.recalculateRequest.isConfirmingPreparationTime === true;
    const isPerformingQuoteDelivery = (onlineOrder.quoteDelivery.isDownloading || onlineOrder.quoteDelivery.shouldPerformCheck) === true;

    return isOngoingRecalculate || isPerformingQuoteDelivery || isOngoingConfirmingPreparationTime;
});
